

// convert image to base64
export function getDataUri(url, callback, outputFormat) {
  var image = new Image();
  image.onload = function () {
    var canvas = document.createElement('canvas');
    canvas.width = this.naturalWidth;
    canvas.height = this.naturalHeight;
    canvas.getContext('2d').drawImage(this, 0, 0);
    let dataURL = canvas.toDataURL(outputFormat);
    let dataURLRawData = dataURL.replace(/^data:image\/(png|jpg);base64,/, '');
    callback(dataURLRawData);
  };
  image.src = url;
}

export function pad(n){
  return ('000'+n).slice(-3);
}

export function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 6 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(6);
  });
}

export function parseQueryString(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}


// WEBPACK FOOTER //
// ./src/utils/_helpers.js